import { Component, ComponentChildren, h } from 'preact'
import PanelHeader from './PanelHeader'
import PanelBody from './PanelBody'
import { IconType } from '../assets'

interface Props {
  children?: ComponentChildren,
  icon?: IconType,
  customClass? : string,
  titleClass? : string,
  bodyClass? : string,
  collapsible?: boolean,
  newStyle?: boolean,
  title?: ComponentChildren,
}
interface State {
  isOpen: boolean
}

class Panel extends Component<Props, State> {
  constructor (props: Props) {
    super(props)
    this.state = {
      isOpen: true
    }
    this.togglePanel = this.togglePanel.bind(this)
  }

  togglePanel () {
    if (!this.props.collapsible) {
      return
    }
    this.setState({ isOpen: !this.state.isOpen })
  }

  render ({ children, customClass, collapsible = false, title, titleClass, bodyClass, newStyle = false }: Props, { isOpen }: State) {
    let hasChildren = (Array(children).toString() !== '')
    let baseClass = 'panel'
    if (newStyle) baseClass = `${baseClass}-new`
    return (
      <div className={`${customClass || ''} ${!isOpen || !hasChildren ? `${baseClass}-collapsed` : ''}`}>
        <div class={baseClass}>
          { title
            ? <PanelHeader
              newStyle={newStyle}
              collapsible={collapsible}
              isOpen={isOpen}
              togglePanel={() => this.togglePanel()}
              title={title}
              customClass={titleClass}
            />
            : null }
          { hasChildren
            ? <PanelBody
              collapsible={collapsible}
              isOpen={isOpen}
              customClass={bodyClass}
            >
              {children}
            </PanelBody> : null }
        </div>
      </div>
    )
  }
}

export default Panel
